import { render, staticRenderFns } from "./PageCollectMarket.vue?vue&type=template&id=a8ba3792&scoped=true"
import script from "./PageCollectMarket.vue?vue&type=script&lang=js"
export * from "./PageCollectMarket.vue?vue&type=script&lang=js"
import style0 from "./PageCollectMarket.vue?vue&type=style&index=0&id=a8ba3792&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ba3792",
  null
  
)

export default component.exports